<template>
  <!-- 固定资产情况 -->
  <div class="rightbox backwhite width86 border-rd3" style="min-height: 800px">
    <div class="toolbtn flex margin-right10">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton class="width100" :loading="true" animated :throttle="200">
      <template slot="template">
        <p
          class="
            flex-betweennowrap
            width98
            margin-auto margin-top20 margin-bot10
          "
        >
          <span class="dimensional">固定资产情况</span>
          <span class="attention f14" @click="tocollectionadd()">新 增</span>
        </p>

        <el-table
          :data="page"
          stripe
          class="eltable width98 margin-auto f14"
          v-if="total != 0"
        >
          <el-table-column label="资产名称" align="left">
            <template slot-scope="scope">
              <span
                class="width100 cursorpointer bluecolor"
                @click="previewreport(scope.row)"
                >{{ scope.row.title }}
              </span></template
            >
          </el-table-column>
          <el-table-column label="采购价格" align="center">
            <template slot-scope="scope">
              {{
                scope.row.price == "" || null
                  ? 0 + "万元"
                  : scope.row.price + "万元"
              }}</template
            ></el-table-column
          >
          <el-table-column
            label="操作方式"
            align="center"
            prop="Informatization"
          />
          <el-table-column label="设备型号" align="center" prop="model" />
          <el-table-column label="设备用途" align="center" prop="usage" />
          <el-table-column label="设备数量" align="center" prop="count" />
          <el-table-column
            label="操作"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <div class="cursorpointer flex">
                <span class="bluecolor" @click="previewreport(scope.row)"
                  >详情</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="collectionmodify(scope.row)"
                  >修改</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="designDetail(scope.row)"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="
            flex-betweennowrap
            width98
            margin-auto
            pad-top30 pad-bot20 pad-left10 pad-right10
          "
          v-if="total != 0"
        >
          <span class="f14" style="color: #409eff"></span>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="currentchange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <!-- 详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetail"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <div class="f16 width98 textalign-left dimensional">固定资产详情</div>
      <div class="margon-auto margin-top30">
        <div class="table">
          <div class="leftboxs">资产名称 :</div>
          <div class="rightboxs">{{ title }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">采购价值 :</div>
          <div class="rightboxs">{{ price }}万</div>
        </div>
        <div class="table">
          <div class="leftboxs">设备型号 :</div>
          <div class="rightboxs">{{ model }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">设备用途 :</div>
          <div class="rightboxs">{{ usage }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">设备数量 :</div>
          <div class="rightboxs">{{ count }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">操作方式 :</div>
          <div class="rightboxs">{{ Informatization }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">备注 :</div>
          <div class="rightboxs">{{ remark }}</div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibledetail = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">固定资产新增</div>
      <div class="pad-top30">
        <div class="bg-box">
          <p><span class="proname">*</span>资产名称</p>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入资产名称"
              v-model="title"
            />
          </div>
        </div>

        <div class="bg-box">
          <div><span class="proname">*</span>采购价格(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入采购价格"
              v-model="price"
            />
          </div>
        </div>

        <div class="bg-box">
          <div><span class="proname">*</span>操作方式</div>
          <div class="box-right">
            <el-select
              class="width100"
              v-model="Informatization"
              placeholder="请选择操作方式"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="bg-box">
          <div><span class="proname">*</span>设备型号</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入设备型号"
              v-model="model"
            />
          </div>
        </div>
        <div class="bg-box">
          <div><span class="proname">*</span>设备用途</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入设备用途"
              v-model="usage"
            />
          </div>
        </div>
        <div class="bg-box">
          <div><span class="proname">*</span>设备数量</div>
          <div class="box-right">
            <el-input-number
              v-model="count"
              @change="handleChange"
              :min="1"
              :max="1000"
              label="设备数量"
            ></el-input-number>
          </div>
        </div>
        <div class="bg-box">
          <div>备注</div>

          <div class="box-right">
            <el-input
              placeholder="请输入项目备注"
              v-model="remark"
              type="textarea"
              :autosize="autosize"
              class="inputDeep"
              maxlength="500"
              @input="monitorInputs"
              rows="5"
              cols="20"
            >
            </el-input>
            <span class="numLimits">{{ nums }}/200</span>
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibleadd = false">取 消</el-button>
        <el-button type="primary" @click="Savechanges()"> 确 定 </el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblemodify"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">固定资产修改</div>
      <div class="pad-top30">
        <div class="bg-box">
          <div><span class="proname">*</span>资产名称</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入资产名称"
              v-model="title"
            />
          </div>
        </div>

        <div class="bg-box">
          <div><span class="proname">*</span>采购价格(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入采购价格"
              v-model="price"
            />
          </div>
        </div>

        <div class="bg-box">
          <div><span class="proname">*</span>操作方式</div>
          <div class="box-right">
            <el-select
              class="inputDeep"
              v-model="Informatization"
              placeholder="请选择操作方式"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="bg-box">
          <div><span class="proname">*</span>设备型号</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入设备型号"
              v-model="model"
            />
          </div>
        </div>
        <div class="bg-box">
          <div><span class="proname">*</span>设备用途</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入设备用途"
              v-model="usage"
            />
          </div>
        </div>
        <div class="bg-box">
          <div><span class="proname">*</span>设备数量</div>
          <div class="box-right">
            <el-input-number
              v-model="count"
              @change="handleChange"
              :min="1"
              :max="1000"
              label="设备数量"
            ></el-input-number>
          </div>
        </div>
        <div class="bg-box">
          <div>备注</div>

          <div class="box-right">
            <el-input
              placeholder="请输入项目备注"
              v-model="remark"
              type="textarea"
              :autosize="autosize"
              class="inputDeep"
              maxlength="500"
              @input="monitorInputs"
              rows="5"
              cols="20"
            >
            </el-input>
            <span class="numLimits">{{ nums }}/200</span>
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisiblemodify = false">取 消</el-button>
        <el-button class="" type="primary" @click="Savechangemodify()">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 错误弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  entfixedassetsindex,
  entfixedassetsdelete,
  entfixedassetsdetail,
  entfixedassetssave,
  entfixedassetsupdate,
} from "@/api/business/business.api";
import callback from "@/components/callback.vue";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      dialogVisibledetail: false,
      title: "",
      model: "",
      usage: "",
      price: "",
      count: "",
      Informatization: "",
      remark: "",
      nums: 200,
      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      modifyid: "",
      options: [
        {
          value: 0,
          label: "手动",
        },
        {
          value: 1,
          label: "气动",
        },
        {
          value: 2,
          label: "数控",
        },
        {
          value: 3,
          label: "智能",
        },
      ],
    };
  },
  components: {
    callback,
  },
  methods: {
    monitorInputs() {
      var txtVal = this.remark.length;
      this.nums = txtVal;
    },
    handleChange(value) {
      this.count = value;
    },
    // 详情
    previewreport(row) {
      this.dialogVisibledetail = true;
      entfixedassetsdetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.model = res.data.data.model;
          this.count = res.data.data.count;
          this.usage = res.data.data.usage;
          if (res.data.data.Informatization == 0) {
            // 0手动 1气动 2数控 3智能
            this.Informatization = "手动";
          } else if (res.data.data.Informatization == 1) {
            // 0手动 1气动 2数控 3智能
            this.Informatization = "气动";
          } else if (res.data.data.Informatization == 2) {
            // 0手动 1气动 2数控 3智能
            this.Informatization = "数控";
          } else {
            this.Informatization = "智能";
          }
          this.price = res.data.data.price;
          this.remark = res.data.data.remark;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 新增
    tocollectionadd() {
      this.dialogVisibleadd = true;
      this.title = "";
      this.price = "";
      this.count = "";
      this.Informatization = "";
      this.model = "";
      this.usage = "";
      this.remark = "";
      this.nums = 200;
    },
    Savechanges() {
      entfixedassetssave({
        title: this.title,
        model: this.model,
        usage: this.usage,
        count: this.count,
        Informatization: this.Informatization,
        price: this.price,
        remark: this.remark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleadd = false;
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 修改
    collectionmodify(row) {
      this.dialogVisiblemodify = true;
      this.modifyid = row.id;
      entfixedassetsdetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.model = res.data.data.model;
          this.usage = res.data.data.usage;
          this.count = res.data.data.count;
          if (res.data.data.Informatization == 0) {
            // 0手动 1气动 2数控 3智能
            this.Informatization = "手动";
          } else if (res.data.data.Informatization == 1) {
            // 0手动 1气动 2数控 3智能
            this.Informatization = "气动";
          } else if (res.data.data.Informatization == 2) {
            // 0手动 1气动 2数控 3智能
            this.Informatization = "数控";
          } else {
            this.Informatization = "智能";
          }
          this.price = res.data.data.price;
          this.remark = res.data.data.remark;
          this.nums = 200 - this.remark.length;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    Savechangemodify() {
      if (this.Informatization == "手动") {
        // 0手动 1气动 2数控 3智能
        this.Informatization = 0;
      } else if (this.Informatization == "气动") {
        // 0手动 1气动 2数控 3智能
        this.Informatization = 1;
      } else if (this.Informatization == "数控") {
        // 0手动 1气动 2数控 3智能
        this.Informatization = 2;
      } else if (this.Informatization == "智能") {
        this.Informatization = 3;
      }
      entfixedassetsupdate({
        id: this.modifyid,
        title: this.title,
        model: this.model,
        usage: this.usage,
        count: this.count,
        Informatization: this.Informatization,
        price: this.price,
        remark: this.remark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleadd = false;
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 删除项目
    designDetail(row) {
      this.$confirm("此操作将删除此项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entfixedassetsdelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      entfixedassetsindex({ page: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.Informatization == 0) {
              i.Informatization = "手动";
            } else if (i.Informatization == 1) {
              i.Informatization = "气动";
            } else if (i.Informatization == 2) {
              i.Informatization = "数控";
            } else if (i.Informatization == 3) {
              i.Informatization = "智能";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entfixedassetsindex({ page: 1, limit: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.Informatization == 0) {
              i.Informatization = "手动";
            } else if (i.Informatization == 1) {
              i.Informatization = "气动";
            } else if (i.Informatization == 2) {
              i.Informatization = "数控";
            } else if (i.Informatization == 3) {
              i.Informatization = "智能";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    refresh() {
      this.$loading.show(); // 显示loading
      entfixedassetsindex({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.Informatization == 0) {
              i.Informatization = "手动";
            } else if (i.Informatization == 1) {
              i.Informatization = "气动";
            } else if (i.Informatization == 2) {
              i.Informatization = "数控";
            } else if (i.Informatization == 3) {
              i.Informatization = "智能";
            }
          });
          this.$loading.hide(); // 隐藏loading
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    entfixedassetsindex({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.page.forEach((i) => {
          if (i.Informatization == 0) {
            i.Informatization = "手动";
          } else if (i.Informatization == 1) {
            i.Informatization = "气动";
          } else if (i.Informatization == 2) {
            i.Informatization = "数控";
          } else if (i.Informatization == 3) {
            i.Informatization = "智能";
          }
        });
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
    <style scoped>
.table {
  width: 98%;
  display: flex;
  margin: auto;
  text-align: left;
  font-size: 14px;
  color: #4f4f4f;
  line-height: 40px;
}
.leftboxs {
  min-width: 70px;
  color: #353a44;
  padding: 0 0 0 5px;
}
.rightboxs {
  margin-left: 10px;
  color: #6a7589;
  padding: 0 0 0 5px;
}

/* 表单盒子 */
.bg-box {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0 10px 0;
  color: #4f4f4f;
  font-size: 14px;
}
.inputDeep {
  width: 100%;
}
.box-right {
  padding-top: 5px;
  width: 100%;
  position: relative;
}
.el-select {
  width: 100%;
}
.el-input-number--small {
  width: 100%;
}
.textarea {
  width: 170%;
  height: 80px;
  border: 1px solid #efefef;
  outline: none;
  padding: 10px 0 0 5px;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__header {
  text-align: left;
}
.errorboxs >>> .el-dialog__title {
  text-align: left;
  font-size: 16px;
  color: #606266;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 10%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f1f3f9;
  height: 40px;
  font-size: 14px;
  border-radius: 3px;
}
</style>